import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OptionSelector } from 'components';

class ColorOption extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    defaultColor: PropTypes.string
  }

  onChange = (name, value) => {
    this.props.onChange('primaryColor', value);
  }

  render() {
    const { value, defaultColor } = this.props;

    const primaryColorValues = [
      { value: 'default', label: 'default', bg: defaultColor || '#EA5323' },
      { value: '#3A99D8', label: '#3A99D8', bg: '#3A99D8' },
      { value: '#EC4889', label: '#EC4889', bg: '#EC4889' },
      { value: '#40DF7D', label: '#40DF7D', bg: '#40DF7D' }
    ];

    return (
      <OptionSelector
        name="primaryColor"
        onChange={this.onChange}
        options={primaryColorValues}
        value={value}
      />
    );
  }
}

export default ColorOption;



// WEBPACK FOOTER //
// ./src/components/EditorOption/ColorOption.js


// WEBPACK FOOTER //
// webpack:///src/components/EditorOption/ColorOption.js